import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { TelephonyComponentsModule } from '../../../telephony-components.module';
import { InteractionsReportComponent } from './interactions-report.component';

const routes: Routes = [
  { path: '', component: InteractionsReportComponent, data: { title: 'Interactions Report' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InteractionsReportRoutingModule {}

@NgModule({
  imports: [
    InteractionsReportRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TelephonyComponentsModule,
  ],
  declarations: [InteractionsReportComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InteractionsReportModule {}
